import React from 'react';
import { Box, Fab, Badge, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import { MSN } from './msnTheme';

/**
 * Botão flutuante - estilo MSN (azul gradiente).
 */
export default function ChatFabButton({ isOpen, unreadCount = 0, onClick }) {
  const label = isOpen ? 'Fechar chat' : 'Abrir chat';

  return (
    <Tooltip title={label} placement="left" arrow>
      <Fab
        aria-label={label}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        sx={{
          width: 56,
          height: 56,
          background: MSN.titleBar,
          border: `2px solid ${MSN.border}`,
          boxShadow: '0 4px 12px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.4)',
          color: MSN.titleBarText,
          '&:hover': {
            background: MSN.sendButtonHover,
            transform: 'scale(1.06)',
            boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
          },
          '&:active': { transform: 'scale(0.98)' },
          '&:focus-visible': { outline: `2px solid ${MSN.buttonBg}`, outlineOffset: 2 },
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          '& .chat-icon': { transition: 'transform 0.25s ease', transform: isOpen ? 'rotate(-90deg)' : 'rotate(0deg)' },
          '& .close-icon': {
            transition: 'transform 0.25s ease',
            transform: isOpen ? 'rotate(0deg)' : 'rotate(90deg)',
            opacity: isOpen ? 1 : 0,
            position: isOpen ? 'relative' : 'absolute',
          },
        }}
      >
        <Badge
          badgeContent={unreadCount > 99 ? '99+' : unreadCount}
          color="error"
          invisible={!unreadCount}
          sx={{
            '& .MuiBadge-badge': {
              minWidth: 20,
              height: 20,
              fontSize: '0.7rem',
              fontWeight: 700,
              boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
              border: '2px solid #fff',
            }
          }}
        >
          <Box sx={{ position: 'relative', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ChatIcon className="chat-icon" sx={{ position: isOpen ? 'absolute' : 'relative', fontSize: 26 }} />
            <CloseIcon className="close-icon" sx={{ fontSize: 26 }} />
          </Box>
        </Badge>
      </Fab>
    </Tooltip>
  );
}
